import { useState, useEffect } from "react";
import AlbumCard from "./albumCard";
import "./album.css";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Cookie from "js-cookie";

const AlbumPage = ({ pageNumber }) => {
  const [answeredQuestions, setAnsweredQuestions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const userData = jwtDecode(Cookie.get("token"));
    const userId = userData.userId;
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    axios
      .get(`${apiUrl}/questions/${userId}`)
      .then((response) => {
        setAnsweredQuestions(response.data);
      })
      .catch((error) => {
        console.error("Error al obtener las preguntas respondidas:", error);
      });
  }, [pageNumber]);

  const number = (pageNumber - 1) * 5;

  useEffect(() => {
    setIsLoading(true);
    const timeoutId = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, [pageNumber]);

  return (
    <>
      {isLoading && (
        <div className="loadership">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      )}
      {!isLoading && (
        <div className="parent">
          {Array.from({ length: 5 }).map((_, index) => {
            const questionNumber = number + index + 1;
            const isAssigned = answeredQuestions?.some(
              (item) => item.cardAssigned === questionNumber
            );
            return isAssigned ? (
              <AlbumCard number={questionNumber} key={index} win={true} />
            ) : (
              <AlbumCard number={questionNumber} key={index} win={false} />
            );
          })}
        </div>
      )}
    </>
  );
};

export default AlbumPage;
